<template>
  <div id="app">
    <div>
      <b-navbar class="header" type="dark" variant="light" fixed="top">
        <b-navbar-brand href="#">
          <img src="./assets/newlogo.png" alt="" />
        </b-navbar-brand>
      </b-navbar>
      <div style="margin-top: 110px"></div>
    </div>

    <router-view></router-view>
    <b-card
      no-body
      class="text-center"
      bg-variant="light"
      border-variant="light"
    >
      <b-card-text>
        <h6>
          Consulte tasas vigentes, terminos y condiciones
          <b-link
            target="_blank"
            href="https://bancojulio.com.ar/wp-content/uploads/2020/11/tasas_tyc.pdf"
            >aquí</b-link
          >
        </h6>

        © Copyright 2020, Banco Julio S.A.
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
@import "../node_modules/@braid/vue-formulate/themes/snow/snow.scss";
</style>
